/** Monatsnamen, wie sie im Bericht stehen (österreichisch: Jänner). */
const MONATE = [
  'Jänner',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
]

/** „2026-09“ → „September 2026“. */
export function monatsName(monat: string): string {
  const [jahr, m] = monat.split('-').map(Number)
  return `${MONATE[(m ?? 1) - 1] ?? monat} ${jahr}`
}

/** Die letzten Monate bis einschließlich des laufenden, neueste zuerst. */
export function letzteMonate(anzahl: number, jetzt = new Date()): string[] {
  const out: string[] = []
  for (let i = 0; i < anzahl; i++) {
    const d = new Date(jetzt.getFullYear(), jetzt.getMonth() - i, 1)
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`)
  }
  return out
}

/** Verfügbarkeit wie im Bericht der Zentrale: erst ab 99,995 % sind es 100 %. */
export function prozent(p: number | null | undefined): string {
  if (p === null || p === undefined) return 'keine Messung'
  if (p >= 99.995) return '100 %'
  return `${p.toFixed(2).replace('.', ',')} %`
}

/** Dauer in Worten: „30 s“, „45 min“, „2 h 5 min“, „2 Tage 2 h“. */
export function dauer(sekunden: number): string {
  if (sekunden < 60) return `${Math.round(sekunden)} s`
  const minuten = Math.round(sekunden / 60)
  const h = Math.floor(minuten / 60)
  const m = minuten % 60
  if (h >= 24) return `${Math.floor(h / 24)} Tage ${h % 24} h`
  if (h > 0 && m > 0) return `${h} h ${m} min`
  if (h > 0) return `${h} h`
  return `${m} min`
}

/** Verfügbarkeit als Zustand für die Farbe: unter 99 % kritisch, unter 99,9 % Warnung. */
export function verfuegbarkeitsStufe(p: number | null): 'ok' | 'warn' | 'crit' | 'off' {
  if (p === null) return 'off'
  if (p < 99) return 'crit'
  if (p < 99.9) return 'warn'
  return 'ok'
}
